import { Injectable } from '@angular/core';
import { CustomAjax } from '../AjaxHelper';
import { Patient } from '../AllTableClasses';

@Injectable({
  providedIn: 'root'
})
export class MembersService {

  constructor(private ajax: CustomAjax) { }

  public MemberGet(searchCriteria: string, includeInactive: boolean, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/Members/MemberGet", `searchCriteria=${searchCriteria}&includeInactive=${includeInactive}`,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public NewPatientsSearch(searchCriteria: string, includeInactive: boolean,  PageSize: number | null = 20, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/Members/NewPatientsSearch", `searchCriteria=${searchCriteria}&includeInactive=${includeInactive}&PageSize=${PageSize}`,
      (data) => {
        if (fn)
          fn(data);

      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }
  public InProgressPatientsSearch(searchCriteria: string, includeInactive: boolean, PageSize: number | null = 20, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/Members/InProgressPatientsSearch", `searchCriteria=${searchCriteria}&includeInactive=${includeInactive}&PageSize=${PageSize}`,
      (data) => {
        if (fn)
          fn(data);

      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }
  public OldPatientsSearch(searchCriteria: string, includeInactive: boolean, PageSize: number | null = 20, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/Members/OldPatientsSearch", `searchCriteria=${searchCriteria}&includeInactive=${includeInactive}&PageSize=${PageSize}`,
      (data) => {
        if (fn)
          fn(data);

      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public MemberGetByGuid(guid: string, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/Members/MemberGetByGuid", `guid=${guid}`,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public MemberSetByGuid(patient: Patient, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.PostData("/Members/MemberSetByGuid", patient,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public PostArCustomer(patient: Patient, update: boolean, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.PostData("/Members/PostArCustomer", { patient: patient, update: update },
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public ActivityHistoryGet(patientID: number, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/Members/ActivityHistoryGet", `patientID=${patientID}`,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public ActivityHistorySetInactive(patient: Patient, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.PostData("/Members/ActivityHistorySetInactive", patient,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }
}
